import { render, staticRenderFns } from "./plafon.vue?vue&type=template&id=0e735593"
import script from "./plafon.vue?vue&type=script&lang=js"
export * from "./plafon.vue?vue&type=script&lang=js"
import style0 from "./plafon.vue?vue&type=style&index=0&id=0e735593&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports